import { IconName, IconProps } from "@theorgchartdev/storybook";
import { ReviewerStatus } from "./PlanSubmisionsTypes";

// Need to add new icon to storybook for pending
const PlanReviewerIcons: Record<ReviewerStatus, { name: IconName; color: IconProps["color"] }> = {
  [ReviewerStatus.Pending]: { name: "circle-ellipsis", color: "tertiary" },
  [ReviewerStatus.Approved]: { name: "circle-check", color: "success" },
  [ReviewerStatus.Rejected]: { name: "circle-xmark", color: "error" }
};

export const getPlanReviewerIcon = (
  status: string
): { name: IconName; color: IconProps["color"] } => {
  if (status in PlanReviewerIcons) {
    return PlanReviewerIcons[status as ReviewerStatus];
  } else {
    console.warn(`Unknown reviewer status: ${status}, defaulting to Pending icon.`);
    return PlanReviewerIcons[ReviewerStatus.Pending];
  }
};
